import overwatchService from '@/http/services/overwatch'
import store from '../../../store'
export default {
  getBooking ({ commit }, id) {
    return overwatchService.getBooking(store.state.apiUrl, id).then((booking) => {
      commit('setBooking', booking.data)
    })
  },
  createSupportTicket ({commit}, data) {
    return overwatchService.createSupportTicket(store.state.apiUrl, data).then((response) => {
      return response.data
    })
  },
  getBookingChangelog ({ commit }, id) {
    return overwatchService.getBookingChangelog(store.state.apiUrl, id).then((booking) => {
      commit('setBookingChangelog', booking.data)
    })
  }
}
